import request from '@/utils/request'

// 分页fba计划
export function listPlan(data) {
  return request({
    url: '/fba/plan/list',
    method: 'get',
    params: data
  })
}
// 分页fba计划
export function uploadPlan(data) {
  return request({
    url: '/fba/plan/upload',
    method: 'post',
    data: data
  })
}
// 分页fba计划
export function handReal(data) {
  return request({
    url: '/fba/plan/handReal',
    method: 'post',
    params: data
  })
}
// 分页fba计划
export function createOrder(data) {
  return request({
    url: '/fba/plan/createOrder',
    method: 'post',
    params: data
  })
}

// 分页fba计划
export function queryPlan(data) {
  return request({
    url: '/fba/plan/queryPlan',
    method: 'get',
    params: data
  })
}


